var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.loaded)?[_c('a-spin')]:[_vm._l((_vm.options),function(service){return [_c('group',{key:service.key,attrs:{"data":service,"get-tag-color":_vm.getTagColor}})]})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }